import React, { useState, useEffect } from "react";
import {
  Grid,
  GridItem,
  Heading,
  FormLabel,
  Input,
  Text,
  InputLeftElement,
  InputGroup,
  Checkbox,
  Select,
  RadioGroup,
  Radio,
  HStack,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Box,
} from "@chakra-ui/react"; // Assuming you are using Chakra UI
import { HSeparator } from "components/separator/Separator";
import { EmailIcon, PhoneIcon, StarIcon } from "@chakra-ui/icons";

const CustomForm = ({
  moduleData,
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldValue,
}) => {
  const contactVal = values;
  //console.log(contactVal, "contactVal............");
  const [selectedOptions, setSelectedOptions] = useState({});
  const user = JSON.parse(localStorage.getItem("user"));
  const [commentList, setCommentList] = useState(values.comments || []); // Keep a local state for comments
  //console.log(moduleData, "moduleData..............", user);
  useEffect(() => {
    moduleData.fields.forEach((field) => {
      if (field.type === "select" && values[field.name]) {
        setSelectedOptions((prev) => ({
          ...prev,
          [field.name]: values[field.name],
        }));
      }
    });
    // addNewComment(values.comments)
  }, [moduleData.fields, values]);
  const addNewComment = (newCommentText) => {
    if (!newCommentText) return; // Prevent adding empty comments

    const newComment = {
      comment: newCommentText,
      createdAt: new Date().toISOString(),
    };

    const updatedComments = [...commentList, newComment];
    setCommentList(updatedComments);
    setFieldValue("comments", updatedComments); // Update formik state once, avoiding infinite loop
  };
  //console.log(values, "values..............");
  const handleSelectChange = (e, field) => {
    const value = e.target.value;
    setSelectedOptions((prev) => ({
      ...prev,
      [field.name]: value,
    }));
    handleChange(e);
    const selectedField = moduleData.fields.find((f) => f.name === field.name);
    const selectedOptionDetails = selectedField.options.find(
      (option) => option.value === value
    );
    if (selectedOptionDetails && selectedOptionDetails.requiresDatePicker) {
      setFieldValue(`${field.name}Date`, "");
    }
  };

  return (
    <Grid templateColumns="repeat(12, 1fr)" gap={3}>
      {moduleData?.headings?.length > 0 ? (
        <>
          {moduleData?.headings?.map((item, ind) => (
            <>
              <GridItem colSpan={{ base: 12 }} key={ind}>
                {ind !== 0 && <HSeparator />}
                <Heading as="h1" size="md" mt="10px">
                  {ind + 1}. {item?.heading}
                </Heading>
              </GridItem>
              {moduleData?.fields
                ?.filter((itm) => itm?.belongsTo === item?._id)
                ?.map((field, index) => (
                  <GridItem colSpan={{ base: 12, sm: 6 }} key={index}>
                    {<span>{field}</span>}
                    {field.type === "check" ? (
                      ""
                    ) : (
                      <FormLabel
                        display="flex"
                        ms="4px"
                        fontSize="sm"
                        fontWeight="500"
                        mb="8px"
                        htmlFor={field.name}
                      >
                        {field.label}{" "}
                        {field.validation &&
                          field.validation.find(
                            (validation) => validation.require
                          ) && <span style={{ color: "red" }}>*</span>}
                      </FormLabel>
                    )}
                    {field.type === "range" ? (
                      <>
                        {values.leadRating || 0}
                        <Slider
                          ml={2}
                          aria-label="slider-ex-1"
                          colorScheme="yellow"
                          value={values.leadRating}
                          min={field?.validation[1]?.value}
                          max={field?.validation[2]?.value}
                          step={0.1}
                          defaultValue={0}
                          onChange={(value) => setFieldValue(field.name, value)}
                        >
                          <SliderTrack>
                            <SliderFilledTrack />
                          </SliderTrack>
                          <SliderThumb boxSize={6}>
                            <Box color="yellow.300" as={StarIcon} />
                          </SliderThumb>
                        </Slider>
                      </>
                    ) : field.type === "radio" ? (
                      <RadioGroup
                        name={field.name}
                        value={values[field.name]}
                        onChange={(value) => setFieldValue(field.name, value)}
                      >
                        <HStack spacing="24px">
                          {field.options.map((option) => (
                            <Radio key={option._id} value={option.value}>
                              {option.name}
                            </Radio>
                          ))}
                        </HStack>
                      </RadioGroup>
                    ) : field.type === "select" ? (
                      <>
                        <Select
                          fontSize="sm"
                          id={field.name}
                          name={field.name}
                          onChange={(e) => handleSelectChange(e, field)}
                          onBlur={handleBlur}
                          value={values[field.name]}
                          fontWeight="500"
                          borderColor={
                            errors?.[field?.name] && touched?.[field?.name]
                              ? "red.300"
                              : null
                          }
                        >
                          {field.options.map((option) => (
                            <option key={option._id} value={option.value}>
                              {option.name}
                            </option>
                          ))}
                        </Select>
                        {selectedOptions[field.name] &&
                          field.options.find(
                            (option) =>
                              option.value === selectedOptions[field.name]
                          )?.requiresDatePicker && (
                            <Input
                              mt={2}
                              type="date"
                              id={`${field.name}Date`}
                              name={`${field.name}Date`}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values[`${field.name}Date`]}
                              fontWeight="500"
                              borderColor={
                                errors?.[`${field.name}Date`] &&
                                touched?.[`${field.name}Date`]
                                  ? "red.300"
                                  : null
                              }
                            />
                          )}
                      </>
                    ) : field.type === "check" ? (
                      <Checkbox
                        isChecked={values[field.name]}
                        onChange={() =>
                          setFieldValue(field.name, !values[field.name])
                        }
                      >
                        {field.label}
                      </Checkbox>
                    ) : (
                      <>
                        <InputGroup>
                          {field.type === "tel" ? (
                            <InputLeftElement
                              pointerEvents="none"
                              children={
                                <PhoneIcon
                                  color="gray.300"
                                  borderRadius="16px"
                                />
                              }
                            />
                          ) : (
                            field.type === "email" && (
                              <InputLeftElement
                                pointerEvents="none"
                                children={
                                  <EmailIcon
                                    color="gray.300"
                                    borderRadius="16px"
                                  />
                                }
                              />
                            )
                          )}
                          <Input
                            fontSize="sm"
                            type={field.type}
                            id={field.name}
                            name={field.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values[field.name]}
                            fontWeight="500"
                            placeholder={`Enter ${field.label} `}
                            borderColor={
                              errors?.[field?.name] && touched?.[field?.name]
                                ? "red.300"
                                : null
                            }
                          />
                        </InputGroup>
                      </>
                    )}
                    {touched[field?.name] && errors?.[field?.name] ? (
                      <Text
                        mb="10px"
                        color={"red"}
                        fontSize="sm"
                        textTransform={"capitalize"}
                      >
                        {" "}
                        {errors?.[field?.name]}
                      </Text>
                    ) : null}
                  </GridItem>
                ))}
            </>
          ))}
          <>
            {moduleData?.fields
              ?.filter((itm) => !itm?.belongsTo)
              ?.map((field, i) => (
                <GridItem colSpan={{ base: 12, sm: 6 }} key={i}>
                  {field.type === "check" ? (
                    ""
                  ) : (
                    <FormLabel
                      display="flex"
                      ms="4px"
                      fontSize="sm"
                      fontWeight="500"
                      mb="8px"
                      htmlFor={field.name}
                    >
                      {field.label}{" "}
                      {field.validation &&
                        field.validation.find(
                          (validation) => validation.require
                        ) && <span style={{ color: "red" }}>*</span>}
                    </FormLabel>
                  )}
                  {field.type === "range" ? (
                    <>
                      {values.leadRating || 0}
                      <Slider
                        ml={2}
                        aria-label="slider-ex-1"
                        colorScheme="yellow"
                        min={field?.validation[1]?.value}
                        max={field?.validation[2]?.value}
                        step={0.1}
                        defaultValue={0}
                        onChange={(value) => setFieldValue(field.name, value)}
                      >
                        <SliderTrack>
                          <SliderFilledTrack />
                        </SliderTrack>
                        <SliderThumb boxSize={6}>
                          <Box color="yellow.300" as={StarIcon} />
                        </SliderThumb>
                      </Slider>
                    </>
                  ) : field.type === "radio" ? (
                    <RadioGroup
                      name={field.name}
                      value={values[field.name]}
                      onChange={(value) => setFieldValue(field.name, value)}
                    >
                      <HStack spacing="24px">
                        {field.options.map((option) => (
                          <Radio key={option._id} value={option.value}>
                            {option.name}
                          </Radio>
                        ))}
                      </HStack>
                    </RadioGroup>
                  ) : field.type === "select" ? (
                    <>
                      <Select
                        fontSize="sm"
                        id={field.name}
                        name={field.name}
                        onChange={(e) => handleSelectChange(e, field)}
                        onBlur={handleBlur}
                        value={values[field.name]}
                        fontWeight="500"
                        borderColor={
                          errors?.[field?.name] && touched?.[field?.name]
                            ? "red.300"
                            : null
                        }
                      >
                        <option value="">Select {field.label}</option>
                        {field.options.map((option) => (
                          <option key={option._id} value={option.value}>
                            {option.name}
                          </option>
                        ))}
                      </Select>
                      {selectedOptions[field.name] &&
                        field.options.find(
                          (option) =>
                            option.value === selectedOptions[field.name]
                        )?.requiresDatePicker && (
                          <Input
                            mt={2}
                            type="date"
                            id={`${field.name}Date`}
                            name={`${field.name}Date`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values[`${field.name}Date`]}
                            fontWeight="500"
                            borderColor={
                              errors?.[`${field.name}Date`] &&
                              touched?.[`${field.name}Date`]
                                ? "red.300"
                                : null
                            }
                          />
                        )}
                    </>
                  ) : field.type === "check" ? (
                    <Checkbox
                      isChecked={values[field.name]}
                      onChange={() =>
                        setFieldValue(field.name, !values[field.name])
                      }
                    >
                      {field.label}
                    </Checkbox>
                  ) : (
                    <>
                      <InputGroup>
                        {field.type === "tel" && (
                          <InputLeftElement
                            pointerEvents="none"
                            children={
                              <PhoneIcon color="gray.300" borderRadius="16px" />
                            }
                          />
                        )}
                        <Input
                          fontSize="sm"
                          type={field.type}
                          id={field.name}
                          name={field.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values[field.name]}
                          fontWeight="500"
                          placeholder={`Enter ${field.label}`}
                          borderColor={
                            errors?.[field?.name] && touched?.[field?.name]
                              ? "red.300"
                              : null
                          }
                        />
                      </InputGroup>
                    </>
                  )}
                  {touched[field?.name] && errors?.[field?.name] ? (
                    <Text mb="10px" fontSize="sm" color={"red"}>
                      {" "}
                      {errors?.[field?.name]}
                    </Text>
                  ) : null}
                </GridItem>
              ))}
          </>
        </>
      ) : (
        <>
          {moduleData?.fields
            ?.filter((itm) => !itm?.belongsTo)
            ?.map((field, index) => (
              <GridItem colSpan={{ base: 12, sm: 6 }} key={index}>
                {field.type === "check" ? (
                  ""
                ) : (
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    mb="8px"
                    htmlFor={field.name}
                  >
                    {field.label}{" "}
                    {field.validation &&
                      field.validation.find(
                        (validation) => validation.require
                      ) && <span style={{ color: "red" }}>*</span>}
                  </FormLabel>
                )}
                {field.type === "range" ? (
                  <>
                    {values.leadRating || 0}
                    <Slider
                      ml={2}
                      aria-label="slider-ex-1"
                      colorScheme="yellow"
                      min={field?.validation[1]?.value}
                      max={field?.validation[2]?.value}
                      step={0.1}
                      defaultValue={0}
                      onChange={(value) => setFieldValue(field.name, value)}
                    >
                      <SliderTrack>
                        <SliderFilledTrack />
                      </SliderTrack>
                      <SliderThumb boxSize={6}>
                        <Box color="yellow.300" as={StarIcon} />
                      </SliderThumb>
                    </Slider>
                  </>
                ) : field.type === "radio" ? (
                  <RadioGroup
                    name={field.name}
                    value={values[field.name]}
                    onChange={(value) => setFieldValue(field.name, value)}
                  >
                    <HStack spacing="24px">
                      {field.options.map((option) => (
                        <Radio key={option._id} value={option.value}>
                          {option.name}
                        </Radio>
                      ))}
                    </HStack>
                  </RadioGroup>
                ) : field.type === "select" ? (
                  <>
                    <Select
                      fontSize="sm"
                      id={field.name}
                      name={field.name}
                      onChange={(e) => handleSelectChange(e, field)}
                      onBlur={handleBlur}
                      value={values[field.name]}
                      fontWeight="500"
                      borderColor={
                        errors?.[field?.name] && touched?.[field?.name]
                          ? "red.300"
                          : null
                      }
                    >
                      <option value="">Select {field.label}</option>
                      {field.options.map((option) => (
                        <option key={option._id} value={option.value}>
                          {option.name}
                        </option>
                      ))}
                    </Select>
                    {selectedOptions[field.name] &&
                      field.options.find(
                        (option) => option.value === selectedOptions[field.name]
                      )?.requiresDatePicker && (
                        <Input
                          mt={2}
                          type="date"
                          id={`${field.name}Date`}
                          name={`${field.name}Date`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values[`${field.name}Date`]}
                          fontWeight="500"
                          borderColor={
                            errors?.[`${field.name}Date`] &&
                            touched?.[`${field.name}Date`]
                              ? "red.300"
                              : null
                          }
                        />
                      )}
                  </>
                ) : field.type === "check" ? (
                  <Checkbox
                    isChecked={values[field.name]}
                    onChange={() =>
                      setFieldValue(field.name, !values[field.name])
                    }
                  >
                    {field.label}
                  </Checkbox>
                ) : (
                  <>
                    <InputGroup>
                      {field.type === "tel" && (
                        <InputLeftElement
                          pointerEvents="none"
                          children={
                            <PhoneIcon color="gray.300" borderRadius="16px" />
                          }
                        />
                      )}
                      <Input
                        fontSize="sm"
                        type={field.type}
                        id={field.name}
                        name={field.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={
                          Array.isArray(values[field.name])
                            ? values[field.name]
                                .map((item) => item.comment)
                                .join(", ") // Extract the 'comment' text
                            : values[field.name] || ""
                        }
                        fontWeight="500"
                        placeholder={`Enter ${field.label}`}
                        borderColor={
                          errors?.[field?.name] && touched?.[field?.name]
                            ? "red.300"
                            : null
                        }
                      />
                    </InputGroup>
                  </>
                )}
                {touched[field?.name] && errors?.[field?.name] ? (
                  <Text mb="10px" fontSize="sm" color={"red"}>
                    {" "}
                    {errors?.[field?.name]}
                  </Text>
                ) : null}
              </GridItem>
            ))}
        </>
      )}
    </Grid>
  );
};

export default CustomForm;
